import React, { useState, useEffect } from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    CircularProgress,
    Typography,
    Alert,
    AlertTitle
} from "@mui/material";
import outWardService from "../../../../services/outWardService";
import invoiceIntegratorService from '../../../../services/invoiceIntegrator';
import userApplicationService from '../../../../services/userApplicationService';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvoice } from '../../../../redux/actions/InvoicesActions';

export const InvoiceSendAll = ({ openDialog, handleCloseDialog, data }) => {
    const [loading, setLoading] = useState(false);
    const [invoiceIntegratorSettingRds, setInvoiceIntegratorSettingRds] = useState(null);
    const [statusList, setStatusList] = useState([]);
    const dispatch = useDispatch();
    const authUserId = useSelector(state => state?.auth?.user?.id);
    const getSettings = async () => {
        var response = await invoiceIntegratorService.getInvoiceIntegratorAccountsApi(authUserId);
        setInvoiceIntegratorSettingRds(response?.data?.data?.data);
    };
    const create = async () => {
        setLoading(true);
        setStatusList([]);

        try {
            const userApplicationsResponse = await userApplicationService.fetchUserApplications();
            const userApplications = userApplicationsResponse?.data?.data || [];
            const activeInvoiceApp = userApplications.find((x) => x.ia && x.invoicePlaceId);

            if (!activeInvoiceApp) {
                setStatusList([{
                    orderNumber: '-',
                    success: false,
                    message: 'Fatura entegratörü ayarlanmamış. Lütfen profil sayfasından e-fatura hesabınızı tanımlayın.'
                }]);
                setLoading(false);
                return;
            }

            for (const invoice of data) {
                try {
                    const request = {
                        invoiceRD: invoice,
                        invoiceIntegratorSettingRds: invoiceIntegratorSettingRds
                    };
                    const response = await outWardService.transferInvoice(request, activeInvoiceApp.applicationName);
                    console.log("response",response);
                    setStatusList(prev => [...prev, {
                        orderNumber: invoice?.order?.orderNumber,
                        success: response.state === 1,
                        message: response.state === 1 
                            ? "İşlem başarılı" 
                            : `Hata oluştu: ${response.message || response.title}`
                    }]);
                } catch (error) {
                    setStatusList(prev => [...prev, {
                        orderNumber: invoice?.order?.orderNumber,
                        success: false,
                        message: error.response?.data?.Message || 'Fatura aktarma işlemi başarısız oldu'
                    }]);
                }
            }
            await dispatch(fetchInvoice(authUserId, 1, 10));
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getSettings();
        if (!openDialog) {
            setLoading(false);
        }
    }, [openDialog]);
    useEffect(() => {
        if (openDialog) {
            create();
        }
    }, [invoiceIntegratorSettingRds]);
    return (
        <Box>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle
                    sx={{
                        color: 'black',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: 2,
                        marginBottom: 3,
                    }}
                >
                    Fatura Aktarma Durumu
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 200
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <CircularProgress sx={{ mb: 2 }} />
                            <Typography variant="body1">
                                Faturalar aktarılıyor, lütfen bekleyin...
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{ width: '100%' }}>
                            {statusList.map((status, index) => (
                                <Alert
                                    key={index}
                                    severity={status.success ? "success" : "error"}
                                    sx={{ width: '100%', mb: 1 }}
                                >
                                    <AlertTitle>
                                        Sipariş No: {status.orderNumber}
                                    </AlertTitle>
                                    {status.message}
                                </Alert>
                            ))}
                        </Box>
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default InvoiceSendAll;